import React from 'react'
import '../../App.css'

const BackgroundParallax = () => {
    return (
        <section className="wrapper">
            <div id="stars"></div>
            <div id="stars2"></div>
            <div id="stars3"></div>
            <div id="stars4"></div>
        </section>
    )
}

export default BackgroundParallax;